// The local API answers with a token-free anonymous read, so its SDK never needs to log in.
const LOCAL_TOKEN = {
  access_token: 'local-anonymous',
  token_type: 'bearer',
  expires_in: 86400,
  scope: 'public-read',
};

export const localTokenStore = {
  getToken: () => LOCAL_TOKEN,
  setToken: () => {},
  removeToken: () => {},
};

export const localFlexApiBaseUrl = () => `${window.location.origin}/api/flex`;

/**
 * Make `sdk.listings.show` ask `localSdk` (our replica-backed API) first and Sharetribe whenever
 * the local answer is anything other than a listing. A 404 is the normal "not served locally"
 * answer; other failures are reported through `onError`. Mutates and returns `sdk`.
 */
export const withLocalListingReads = (sdk, localSdk, onError = () => {}) => {
  const sharetribeShow = sdk.listings?.show;
  const localShow = localSdk.listings?.show;
  if (typeof sharetribeShow !== 'function' || typeof localShow !== 'function') {
    return sdk;
  }
  sdk.listings.show = (params, opts) =>
    Promise.resolve()
      .then(() => localShow(params, opts))
      .then(response => {
        if (response?.data?.data?.type !== 'listing') {
          throw new Error('Unexpected local listing response');
        }
        return response;
      })
      .catch(e => {
        if (e?.status !== 404) onError(e);
        return sharetribeShow(params, opts);
      });
  return sdk;
};
